var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEbayImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 8,
    viewBox: "0 0 20 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_49_1221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.58406 1.74915C1.17814 1.74915 0.0065918 2.34561 0.0065918 4.1451C0.0065918 5.5707 0.794374 6.46845 2.62036 6.46845C4.76964 6.46845 4.90741 5.05266 4.90741 5.05266H3.86599C3.86599 5.05266 3.6427 5.81501 2.55683 5.81501C1.67243 5.81501 1.03633 5.21757 1.03633 4.38017H5.01632V3.85468C5.01632 3.02623 4.4904 1.74915 2.58406 1.74915ZM2.54776 2.42074C3.38962 2.42074 3.96355 2.93648 3.96355 3.70947H1.05936C1.05936 2.88885 1.80848 2.42074 2.54776 2.42074Z",
    fill: "#E53238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.01568 0.00665283V5.56477C5.01568 5.88027 4.99316 6.32327 4.99316 6.32327H5.98646C5.98646 6.32327 6.02212 6.0051 6.02212 5.71433C6.02212 5.71433 6.51287 6.48209 7.84727 6.48209C9.25244 6.48209 10.2069 5.50652 10.2069 4.10882C10.2069 2.80856 9.3302 1.76278 7.84954 1.76278C6.463 1.76278 6.03215 2.51152 6.03215 2.51152V0.00665283H5.01568ZM7.59315 2.45026C8.54737 2.45026 9.15415 3.15845 9.15415 4.10882C9.15415 5.12792 8.45334 5.79461 7.59996 5.79461C6.58152 5.79461 6.03215 4.99942 6.03215 4.1179C6.03215 3.29649 6.52511 2.45026 7.59315 2.45026Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6754 1.74915C10.5603 1.74915 10.4246 2.90727 10.4246 3.09233H11.4774C11.4774 3.09233 11.5326 2.4162 12.6028 2.4162C13.2982 2.4162 13.837 2.7345 13.837 3.34645V3.56426H12.6028C10.9642 3.56426 10.0979 4.04362 10.0979 5.01636C10.0979 5.97368 10.8983 6.49455 11.98 6.49455C13.4541 6.49455 13.9289 5.68001 13.9289 5.68001C13.9289 6.00399 13.9539 6.32324 13.9539 6.32324H14.8898C14.8898 6.32324 14.8535 5.92752 14.8535 5.67434V3.48599C14.8535 2.05111 13.6961 1.74915 12.6754 1.74915ZM13.837 4.21771V4.50813C13.837 4.88691 13.6033 5.82862 12.2273 5.82862C11.4737 5.82862 11.1507 5.45256 11.1507 5.01636C11.1507 4.22282 12.2386 4.21771 13.837 4.21771Z",
    fill: "#F5AF02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2866 1.93085H15.471L17.1707 5.33614L18.8666 1.93085H19.9394L16.8505 7.99334H15.7251L16.6165 6.30334L14.2866 1.93085Z",
    fill: "#86B817"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_49_1221"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9461,
    height: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEbayImage);
export default __webpack_public_path__ + "static/media/ebay-image.f89c47d10a7ea297c0e82ebb41282754.svg";
export { ForwardRef as ReactComponent };